import { Box, Button, FormLabel, Grid, MenuItem, Stack, Typography } from "@mui/material";
import { Form, Formik } from "formik";
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from "react-router-dom";
import NormalInput from "../../../components/inputs/normalInput";
import CustomTextArea from "../../../components/inputs/textarea";
import BasicSelect from "../../../components/select";
import Schema from "../../../schema";
import { saveCommunityPost, getAllGroups } from "../action";
import { useEffect, useState } from "react";
import { resetNotification, updateNotification } from "../notificationSlice";
import imageIconWhite from '../../../assets/images/icons/ImageIconWhite.svg'
import check from '../../../assets/images/icons/greenCheck.svg'
import imageIcon from '../../../assets/images/icons/imageIcon.svg'
import deleteIconRed from '../../../assets/images/icons/deleteIconRed.svg'
const CommunityPostForm = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { state } = useLocation();
    const {
        listing,
    } = useSelector((state) => state.notificationSlice);
    const [preview, setPreview] = useState(state?.image || "");
    useEffect(() => {
        dispatch(
            updateNotification({
                filters: {
                    type: 'community'
                },limit:100, page:0,
            }),
        );
        dispatch(getAllGroups())
        return()=>dispatch(resetNotification())
    }, []);

    const initialValues = {
        name: state?.name || "",
        image: state?.image || "",
        description: state?.description || "",
        id: state?.id || null,
        communityId: state?.communityId || null
    }

    return (
        <Box>
            <Stack direction={"row"} alignItems={"center"} spacing={3} mb={2}>
                <Stack
                    direction={"row"}
                    alignItems={"center"}
                    justifyContent={"space-between"}
                    sx={{
                        minHeight: '42px', paddingX: '16px'
                    }}
                >

                    <Typography variant="h1" className="page-title">
                        {state?.id ? "Edit" : "Create"}  Post
                    </Typography>

                    <Stack
                        className="backText"
                        direction={"row"}
                        gap={1}
                        alignItems={"center"}
                        sx={{ cursor: "pointer" }}
                        onClick={() => { }}
                    >
                        <svg
                            width="16"
                            height="12"
                            viewBox="0 0 16 12"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M8.5 7.66667L5.16667 4.33333L8.5 1M4.33333 7.66667L1 4.33333L4.33333 1"
                                stroke="#0077FF"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                            <path
                                d="M5.1665 4.33331H10.9998C11.8839 4.33331 12.7317 4.6845 13.3569 5.30962C13.982 5.93474 14.3332 6.78259 14.3332 7.66665C14.3332 8.5507 13.982 9.39855 13.3569 10.0237C12.7317 10.6488 11.8839 11 10.9998 11H10.1665"
                                stroke="#0077FF"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                        </svg>
                        <Typography variant="h5" color={"primary"} onClick={() => { dispatch(updateNotification({ filters: {} })); navigate("/notification/communityposts") }}>
                            Back
                        </Typography>
                    </Stack>
                </Stack>
            </Stack>

            <Box
                sx={{
                    backgroundColor: '#fff',
                    transition: 'all .5s ease-in-out',
                    position: 'relative',
                    border: '1px solid rgba(170, 170, 170, 0.3)',
                    borderRadius: '12px',
                    boxShadow: '0px 5px 5px 0px rgba(82, 63, 105, 0.05)',
                    overflow: 'hidden', marginX: '20px'
                }}
            >
                <Formik
                    initialValues={initialValues}
                    validationSchema={Schema.communityPostsAdd}
                    enableReinitialize={true}
                    onSubmit={(values) => {
                        dispatch(saveCommunityPost(values, navigate));
                    }}
                >
                    {({
                        errors,
                        handleBlur,
                        handleChange,
                        touched,
                        values,
                        setFieldError,
                        setFieldTouched,
                        setFieldValue
                    }) => {
                        const handleDeletePostImage = (e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            handleChange({
                                target: {
                                    name: "image",
                                    value: "",
                                }
                            })
                            setPreview(null);
                        }

                        const handleDrop = (e) => {
                            e.preventDefault();
                            const file = e.dataTransfer.files[0];
                            handleFile(file);
                        };
                        const handleFileChange = (e) => {
                            const file = e.target.files[0];
                            handleFile(file);
                        };
                        const handleFile = (file) => {
                            if (!file) return;

                            setFieldTouched("image", true, false);
                            setFieldValue("image", file);

                            const reader = new FileReader();
                            reader.onload = (e) => setPreview(e.target.result);
                            reader.readAsDataURL(file);
                        };

                        return (
                            <Form>
                                <Grid container spacing={3} p={3} ml={1} bgcolor={"white"}>
                                    <Grid item xs={12} lg={4} md={4} sm={12}>
                                        <Grid container spacing={2}  >
                                            <Grid item xs={12} lg={12} md={12} sm={12}>
                                                <FormLabel required focused={false}>Name</FormLabel>
                                                <NormalInput
                                                    name={"name"}
                                                    type={"text"}
                                                    focused={false}
                                                    label={("")}
                                                    sizeval="medium"
                                                    values={values.name}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    error={Boolean(touched.name) && errors.name}
                                                    helperText={touched.name && errors.name}
                                                />
                                            </Grid>
                                            <Grid item xs={12} lg={12} md={12} sm={12}>
                                                <FormLabel required focused={false}>Community</FormLabel>
                                                <BasicSelect
                                                    required={false}
                                                    name={`communityId`}
                                                    label={("")}
                                                    values={values.communityId}
                                                    handleChange={handleChange}
                                                    options={listing?.map((item) => {
                                                        return (
                                                            <MenuItem value={item.id} key={item.id}>
                                                                {item.name}
                                                            </MenuItem>
                                                        );
                                                    })}
                                                    handleBlur={handleBlur}
                                                />
                                                {errors.communityId && touched.communityId && (
                                                    <p
                                                        className="error"
                                                    >
                                                        {`${errors?.communityId}`}
                                                    </p>
                                                )}
                                            </Grid>

                                            <Grid item xs={12} lg={12} md={12} sm={12}>
                                                <FormLabel required focused={false}>Post Image</FormLabel>
                                                <Box
                                                    onDrop={handleDrop}
                                                    onDragOver={(e) => e.preventDefault()}
                                                    sx={{
                                                        border: '1px solid #aaaaaaab',
                                                        borderRadius: '8px',
                                                        padding: '16px',
                                                        textAlign: 'center',
                                                        cursor: 'pointer',
                                                        background: 'white',
                                                        position: 'relative',
                                                        width: '100%', height: '150px'
                                                    }}>
                                                    <input
                                                        type="file"
                                                        accept="image/*"
                                                        id="fileInput"
                                                        style={{ display: 'block', height: '100%', width: '100%', border: '2px solid red', opacity: 0 }}
                                                        onChange={handleFileChange}
                                                    />
                                                    <label htmlFor="fileInput" style={{ width: '100%', height: '100%', position: 'absolute', top: 0, left: 0, padding: '16px', cursor: 'pointer' }}>
                                                        {preview ? (
                                                            <Stack
                                                                direction="row" justifyContent="flex-start" gap={0} alignItems="center"
                                                                sx={{
                                                                    width: '100%',
                                                                    height: '100%',
                                                                    borderRadius: 2,
                                                                    border: '0px solid red'
                                                                }}>
                                                                <Stack direction="row" justifyContent="flex-start" alignItems="center" gap={2} sx={{ height: '100px', width: '350px', background: '#F0F0F0', borderRadius: '10px', padding: '14px' }}>
                                                                    <Box sx={{ height: '65px', width: '65px', position: 'relative' }}>
                                                                        <img src={preview} alt="preview" style={{ height: '100%', width: '100%', objectFit: 'cover', borderRadius: '5px' }} />
                                                                        <div style={{ position: 'absolute', top: 0, left: 0, background: 'rgba(0,0,0,0.5)', height: '100%', width: '100%', padding: '17px', borderRadius: '5px' }}>
                                                                            <img src={imageIconWhite} alt="imageIconWhite" style={{ height: '24px', width: '24px' }} />
                                                                        </div>
                                                                    </Box>
                                                                    <Typography sx={{ color: '#726C6C', fontSize: '14px', fontWeight: 400, minWidth: '200px', textAlign: 'left' }}>{(values?.image?.name || values?.image)?.substring(0, 25) || "Post Image"}</Typography>
                                                                    <img src={check} alt="check" style={{ height: '24px', width: '24px' }} />
                                                                </Stack>
                                                                <Button sx={{ "&:hover": { background: 'transparent' } }} disableRipple onClick={handleDeletePostImage}><img src={deleteIconRed} alt="check" style={{ height: '24px', width: '24px' }} /></Button>
                                                            </Stack>
                                                        ) : (
                                                            <Stack
                                                                direction="column" justifyContent="center" gap={1} alignItems="center"
                                                                sx={{
                                                                    width: '100%',
                                                                    height: '100%',
                                                                    borderRadius: 2,
                                                                    border: '0px solid red'
                                                                }}>
                                                                <img src={imageIcon} alt="" style={{ height: '32px', width: '32px' }} />
                                                                <Typography variant="body1" sx={{ mt: 0.7, fontSize: '12px', fontWeight: 600 }}>
                                                                    <span style={{ color: 'var(--color-blue)', textDecoration: 'underline', }}>
                                                                        Click to upload
                                                                    </span>{' '}
                                                                    or drag and drop
                                                                </Typography>
                                                            </Stack>
                                                        )}
                                                    </label>
                                                </Box>
                                                {errors.image && touched.image && (
                                                    <p
                                                        className="error"

                                                    >
                                                        {`${errors?.image}`}
                                                    </p>
                                                )}
                                            </Grid>


                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12} lg={8} md={8} sm={12}>
                                        <Grid container spacing={2} pr={4}  >
                                            <Grid item xs={12} lg={12} md={12} sm={12}>
                                                <FormLabel>Post Description</FormLabel>
                                                <CustomTextArea
                                                    name={"description"}
                                                    type={"text"}
                                                    focused={false}
                                                    label={("")}
                                                    sizeval="medium"
                                                    values={values.description}
                                                    onChange={handleChange}
                                                    placeholder=" "
                                                    multiline={true}
                                                    style={{ m: 0, p: 0, height: '90px' }}
                                                />
                                                {errors?.description && touched.description && (
                                                    <p
                                                        className="error"

                                                    >
                                                        {`${errors?.description}`}
                                                    </p>
                                                )}
                                            </Grid>
                                        </Grid>
                                        <Grid item xs={12} pr={4} lg={12} md={12} sm={12} className="pt-0" container alignItems={"end"} justifyContent="flex-end">
                                            <Stack direction={"row"} spacing={1} mt={2}>
                                                <button className="btnSecondary" onClick={() => navigate("/notification/communityposts")}>Cancel</button>
                                                <button
                                                    className="btnPrimary"
                                                    type="submit"
                                                >
                                                    {state?.id ? "Update" : "Create"} Post
                                                </button>
                                            </Stack>
                                        </Grid>

                                    </Grid>

                                </Grid>
                            </Form>
                        );
                    }}
                </Formik>
            </Box >
        </Box >

    );

}
export default CommunityPostForm;